import { render, staticRenderFns } from "./AuthMonitoring.vue?vue&type=template&id=06c4be2b"
import script from "./AuthMonitoring.vue?vue&type=script&lang=js"
export * from "./AuthMonitoring.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports